module.exports = __webpack_public_path__ + "img/empty-state.96b42ec4.svg";